export default __webpack_public_path__ + "logo.f8d4e821.png";